(function(){
  if (window.__intBandsBooted) return;
  window.__intBandsBooted = true;

  var __bandsCfg = {};
  try { __bandsCfg = JSON.parse((document.getElementById('int-bands-cfg') || {}).textContent || '{}'); } catch (e) {}

  var cfg = {
    isWallArt: __bandsCfg.isWallArt,
    isResults: __bandsCfg.isResults,
    shipMode: __bandsCfg.shipMode,
    /* 2026-10-06: band words come from the locale keys in int-bands-cfg (snippets/int-collection-bands.liquid),
       English only as the fallback if that block is missing. */
    shipLabel: __bandsCfg.shipLabel != null ? __bandsCfg.shipLabel : "Free shipping",
    shipOver: __bandsCfg.shipOver || "over",
    bundleLabel: __bandsCfg.bundleLabel,
    bundleValue: __bandsCfg.bundleValue,
    klarnaText: __bandsCfg.klarnaText || "Pay later, interest free with",
    noKlarna: __bandsCfg.noKlarna === true,
    quizLabel: __bandsCfg.quizLabel || "Find your Word",
    quizValue: __bandsCfg.quizValue || "Take the Quiz &rarr;",
    googleText: __bandsCfg.googleText || "5.0 · Google Reviews",
    reviewUrl: "https://g.page/r/CdpIQlNSEEsuEBM/review",
    /* 2026-10-06: the Find your Word quiz, locale aware. Shopify.routes.root is "/" or "/da/" (with
       the slash), so it joins without a double slash. It went to the Words overview page before. */
    quizUrl: ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'pages/your-word-of-intention'
  };

  var KLARNA_LOGO = "https://cdn.shopify.com/s/files/1/0924/7185/3320/files/62b32650b223544c209f5eb6.png?v=1772297001";
  var GOOGLE_SVG = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">'
    + '<path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#666666"/>'
    + '<path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#666666"/>'
    + '<path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#666666"/>'
    + '<path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#666666"/></svg>';

  /* 2026-10-26 checkout-bounce: no Klarna band on the US site (noKlarna from int-bands-cfg). */
  var rotation = cfg.noKlarna ? ['shipping','bundle'] : ['shipping','bundle','klarna'];
  if (!cfg.isWallArt && !cfg.isResults) rotation.push('quiz');

  function node(html){ var t=document.createElement('template'); t.innerHTML=html.trim(); return t.content.firstChild; }

  function makeBand(type){
    if (type==='google') return node('<li class="sa-band sa-band--google" data-sa-band="1">'
      + '<a class="sa-band-google" href="'+cfg.reviewUrl+'" target="_blank" rel="noopener">'
      + '<span class="sa-band-stars">★★★★★</span>'
      + '<span class="sa-band-gtext">'+cfg.googleText+'</span>'+GOOGLE_SVG+'</a></li>');
    if (type==='shipping') return node('<li class="sa-band sa-band--shipping" data-sa-band="1">'
      + (cfg.shipLabel ? '<span class="sa-band-label">'+cfg.shipLabel+'</span>' : '')
      + '<span class="sa-band-value">'+cfg.shipOver+' <span data-int-freeship="'+cfg.shipMode+'"></span></span></li>');
    if (type==='bundle') return node('<li class="sa-band sa-band--bundle" data-sa-band="1">'
      + '<span class="sa-band-label">'+cfg.bundleLabel+'</span>'
      + '<span class="sa-band-value">'+cfg.bundleValue+'</span></li>');
    if (type==='klarna') return node('<li class="sa-band sa-band--klarna" data-sa-band="1">'
      + '<span class="sa-band-klarna"><span class="sa-band-value">'+cfg.klarnaText+'</span>'
      + '<img class="sa-band-klogo" src="'+KLARNA_LOGO+'" alt="Klarna" loading="lazy"></span></li>');
    if (type==='quiz') return node('<li class="sa-band sa-band--quiz" data-sa-band="1" role="button" tabindex="0">'
      + '<span class="sa-band-label">'+cfg.quizLabel+'</span>'
      + '<span class="sa-band-value">'+cfg.quizValue+'</span></li>');
    return null;
  }

  function cardList(grid){
    var out=[], ch=grid.children;
    for (var i=0;i<ch.length;i++){ var n=ch[i]; if (n.nodeType===1 && n.classList.contains('sa-card')) out.push(n); }
    return out;
  }

  var working=false, grid=null;

  function build(){
    if (working) return;
    grid = grid || document.getElementById('sa_grid');
    if (!grid) return;
    working = true;
    var old = grid.querySelectorAll('li.sa-band');
    for (var k=0;k<old.length;k++) old[k].remove();
    if (window.innerWidth > 820){ working=false; return; }
    var cards = cardList(grid);
    if (!cards.length){ working=false; return; }
    var cols = 2;
    try { var n = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length; if (n>=1) cols=n; } catch(e){}
    var per = cols * 2;
    var ri = 0;
    for (var i = per; i <= cards.length; i += per){
      var anchor = cards[i-1];
      var band = makeBand(rotation[ri % rotation.length]); ri++;
      if (band) anchor.parentNode.insertBefore(band, anchor.nextSibling);
    }
    /* Bands are built long after DOMContentLoaded, so the source of truth has
       already run its own pass. Paint the mount points we just inserted. */
    if (typeof window.__intPaintFreeShip === 'function') window.__intPaintFreeShip(grid);
    working = false;
  }

  var t=0;
  function schedule(){ clearTimeout(t); t=setTimeout(build, 80); }

  function relevant(muts){
    for (var i=0;i<muts.length;i++){
      var m=muts[i], j;
      for (j=0;j<m.addedNodes.length;j++){ var a=m.addedNodes[j]; if (a.nodeType===1 && a.classList.contains('sa-card')) return true; }
      for (j=0;j<m.removedNodes.length;j++){ var r=m.removedNodes[j]; if (r.nodeType===1 && r.classList.contains('sa-card')) return true; }
    }
    return false;
  }

  /* 2026-10-06: the band opens the quiz in place (snippets/int-quiz-open-boot.liquid); the quiz page is the fallback */
  function openQuiz(el){ if (typeof window.intentionOpenQuiz === 'function') window.intentionOpenQuiz(el); else if (typeof window.__intBundleOpenQuiz === 'function') window.__intBundleOpenQuiz(); else window.location.href = cfg.quizUrl; }
  document.addEventListener('click', function(e){ var q=e.target.closest && e.target.closest('.sa-band--quiz'); if (q){ e.preventDefault(); openQuiz(q); } });
  document.addEventListener('keydown', function(e){ if (e.key==='Enter'||e.key===' '){ var q=e.target.closest && e.target.closest('.sa-band--quiz'); if (q){ e.preventDefault(); openQuiz(q); } } });

  function init(){
    grid = document.getElementById('sa_grid');
    if (!grid) return;
    build();
    var mo = new MutationObserver(function(muts){ if (working) return; if (relevant(muts)) schedule(); });
    mo.observe(grid, { childList:true });
    var rt=0;
    window.addEventListener('resize', function(){ clearTimeout(rt); rt=setTimeout(build, 150); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
